import { ref } from 'vue'
import { getLinkusAvailability, type LinkusAvailability } from '@/services/wootdashLinkus'

// Se o agente logado pode ligar pelo Linkus — um estado só pra todos os botões da tela. Busca uma vez por sessão
// do navegador; refreshLinkus() de novo quando algo muda (ex: o agente salvou o ramal no perfil).
const availability = ref<LinkusAvailability | null>(null)
let inflight: Promise<void> | null = null

export function loadLinkus(token: string, force = false): Promise<void> {
  if (!token) return Promise.resolve()
  if (availability.value && !force) return Promise.resolve()
  if (inflight && !force) return inflight
  inflight = getLinkusAvailability(token).then(a => { availability.value = a }).finally(() => { inflight = null })
  return inflight
}

export function refreshLinkus(token: string): Promise<void> {
  return loadLinkus(token, true)
}

export function useLinkus() {
  return { availability }
}

/** Só pra testes. */
export function resetLinkus() {
  availability.value = null
  inflight = null
}
